import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useClientProfile } from '../context/ClientProfileContext';
import { useVendrProducts } from '../context/VendrProductsContext';
import { useAmazonRegistry } from '../context/AmazonBrandRegistryContext';
import { useAmazonProducts } from '../context/AmazonProductsContext';
import VendrLayout from '../VendrLayout';
import './VendrDashboard.css';

const VendrDashboard = () => {
  const { profile, loading: profileLoading, isSetupComplete } = useClientProfile();
  const { products, loading: productsLoading } = useVendrProducts();
  const { isAmazonEnabled, isAmazonSubmitted, loading: amazonLoading } = useAmazonRegistry();
  const { products: amazonProducts, loading: amazonProductsLoading } = useAmazonProducts();

  if (profileLoading || amazonLoading) {
    return (
      <VendrLayout>
        <div className="vendr-dashboard-loading">Loading...</div>
      </VendrLayout>
    );
  }

  if (!isSetupComplete) {
    return <Navigate to="/vendr/setup" replace />;
  }

  if (isAmazonEnabled && !isAmazonSubmitted) {
    return <Navigate to="/vendr/amazon-registry" replace />;
  }

  const productCount = products?.length ?? 0;
  const amazonProductCount = amazonProducts?.length ?? 0;

  return (
    <VendrLayout>
      <div className="vendr-dashboard">
        <h1 className="vendr-dashboard-title">Dashboard</h1>
        <p className="vendr-dashboard-subtitle">
          Welcome back{profile?.first_name ? `, ${profile.first_name}` : ''}.
        </p>

        <div className="vendr-dashboard-cards">
          <Link to="/vendr/products" className="vendr-dashboard-card vendr-dashboard-card-products">
            <span className="vendr-dashboard-card-value">{productsLoading ? '…' : productCount}</span>
            <span className="vendr-dashboard-card-label">Products</span>
          </Link>
          <Link to="/vendr/products/new" className="vendr-dashboard-card vendr-dashboard-card-add">
            <span className="vendr-dashboard-card-label">Add product</span>
          </Link>
        </div>

        {!productsLoading && productCount === 0 && (
          <div className="vendr-dashboard-empty">
            <p>You haven't added any products yet.</p>
            <Link to="/vendr/products/new" className="vendr-dashboard-cta">
              Add your first product
            </Link>
          </div>
        )}

        {isAmazonEnabled && isAmazonSubmitted && (
          <div className="vendr-dashboard-amazon-section">
            <h2 className="vendr-dashboard-section-title">Amazon Products</h2>
            <div className="vendr-dashboard-cards">
              <div className="vendr-dashboard-card vendr-dashboard-card-amazon">
                <span className="vendr-dashboard-card-value">
                  {amazonProductsLoading ? '…' : amazonProductCount}
                </span>
                <span className="vendr-dashboard-card-label">Amazon Products</span>
              </div>
              <Link to="/vendr/amazon-products/new" className="vendr-dashboard-card vendr-dashboard-card-add">
                <span className="vendr-dashboard-card-label">Add Amazon product</span>
              </Link>
            </div>

            {!amazonProductsLoading && amazonProductCount > 0 && (
              <div className="vendr-dashboard-amazon-list">
                {amazonProducts.map(p => (
                  <Link
                    key={p.id}
                    to={`/vendr/amazon-products/edit/${p.id}`}
                    className="vendr-dashboard-amazon-item"
                  >
                    <span className="vendr-dashboard-amazon-name">{p.product_name}</span>
                    <span className={`vendr-dashboard-amazon-status vendr-dashboard-amazon-status--${p.status}`}>
                      {p.status}
                    </span>
                  </Link>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </VendrLayout>
  );
};

export default VendrDashboard;
